module.exports = {
  layouts: [
    //Streams
    {
      name: "Carousel - Portrait",
      description:
        "Shows more streams per screen with portrait thumbnails. Scroll less, discover more.",
      note: "You can add as many Streams as you’d like to in this layout.",
      icon: "/images/hub/layouts/carousel_portrait.gif",
      dimensions: "236 * 315 px",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "carousel_portrait",
              entityType: "stream",
              layoutStyle: "carousel",
              cardStyle: "large",
              smartFilter: "recently_viewed_streams",
            },
          },
        ],
      },
    },
    {
      name: "Carousel - Landscape",
      entityType: "stream",
      description:"Fewer streams per screen with landscape thumbnails, with a wider view for more details. Sometimes less is more (except when it comes to pizza).",
      note: "You can add as many Streams as you’d like to in this layout.",
      icon: "/images/hub/layouts/carousel_landscape.gif",
      dimensions: "236 * 102 px",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              entityType: "stream",
              contents: [],
              type: "carousel_landscape",
              layoutStyle: "carousel",
              cardStyle: "small",
              smartFilter: "recently_viewed_streams",
            },
          },
        ],
      },
    },

    //Collections
    {
      name: "Carousel",
      description:
        "Fewer collections per screen with landscape thumbnails, with a wider view for more details. Sometimes less is more (except when it comes to pizza).",
      note: "You can add as many Collections as you’d like to in this layout.",
      icon: "/images/hub/layouts/collections_carousel.gif",
      dimensions: "193 * 135 px",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              entityType: "collection",
              type: "collections_carousel",
              layoutStyle: "carousel",
              cardStyle: "small",
              smartFilter: "my_collections",
            },
          },
        ],
      },
    },
    {
      name: "Promoted Content",
      description:
        "Spotlight your prime-time content and ensure it stand tall and strong",
      note: "We recommend you to choose a Collection of your choice you'd like to promote.",
      icon: "/images/hub/layouts/assets_carousel.gif",
      dimensions: "",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "promoted_content__",
              entityType: "collection",
              layoutStyle: "promoted_content",
              cardStyle: "small",
            },
          },
        ],
      },
    },
    {
      name: "Folders",
      description:
        "Sort collections into sections your team can actually navigate. No more 'I know it's in here somewhere'.",
      note: "You can add as many Collections as you’d like to in this layout.",
      icon: "/images/hub/layouts/collections_folders.gif",
      dimensions: "",
      data: {
        columns: [
          {
            width: 1,
            section: {
              title: "Untitled 1",
              contents: [],
              entityType: "collection",
              type: "collections_folders",
              layoutStyle: "collection_folders",
              cardStyle: "small",
              smartFilter: undefined,
            },
          },
          {
            width: 1,
            section: {
              title: "Untitled 2",
              contents: [],
              entityType: "collection",
              type: "collections_folders",
              layoutStyle: "collection_folders",
              cardStyle: "small",
              smartFilter: undefined,
            },
          },
        ],
      },
    },

    //Assets
    {
      name: "Carousel",
      description: "A carousel scroll of Assets with portrait thumbnails.",
      note: "You may add as many Assets as you’d like to in this layout.",
      icon: "/images/hub/layouts/assets_carousel.gif",
      dimensions: "128 * 150 px",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "assets_carousel",
              entityType: "asset",
              layoutStyle: "carousel",
              cardStyle: "small",
              smartFilter: "most_viewed_assets",
            },
          },
        ],
      },
    },

    {
      name: "Promoted Content",
      description:
        "Spotlight your prime-time content and ensure it stand tall and strong",
      note: "We recommend you to choose an Asset of your choice you'd like to promote.",
      icon: "/images/hub/layouts/assets_carousel.gif",
      dimensions: "",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "promoted_content__",
              entityType: "asset",
              layoutStyle: "promoted_content",
              cardStyle: "small",
            },
          },
        ],
      },
    },

    {
      name: "Metro Combination",
      description:
        "A descriptive snapshot of assets with portrait thumbnails. Provides a helpful summary of the assets and enables easy discovery.",
      note: "Recommended number of Assets to display in this section is 4.",
      icon: "/images/hub/layouts/metro_combination.gif",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "metro_combination",
              entityType: "asset",
              layoutStyle: "metro",
              cardStyle: "small",
              smartFilter: "most_viewed_assets",
            },
          },
        ],
      },
    },
    {
      name: "Info Cards",
      description:
        "One asset highlighted as an info card while others are smaller thumbnails around it. Ideal for related assets—a family reunion but less awkward!",
      note: "Recommended number of Assets to display in each section is 3.",
      icon: "/images/hub/layouts/assets_two_column_list.gif",
      data: {
        columns: [
          {
            width: 1,
            section: {
              title: "Section 1",
              contents: [],
              type: "assets_two_column_list",
              entityType: "asset",
              layoutStyle: "list",
              cardStyle: "small",
              smartFilter: "most_viewed_assets",
            },
          },
          {
            width: 1,
            section: {
              title: "Section 2",
              contents: [],
              type: "assets_two_column_list",
              entityType: "asset",
              layoutStyle: "list",
              cardStyle: "small",
              smartFilter: "most_viewed_assets",
            },
          },
        ],
      },
    },
    // coaching
    {
      name: "Carousel",
      description: "A carousel scroll of HeySales learnings.",
      icon: "/images/hub/layouts/collections_carousel.gif",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "coaching_carousel",
              entityType: "coaching",
              layoutStyle: "carousel",
              cardStyle: "small",
              smartFilter: "published_learnings",
            },
          },
        ],
      },
    },
    {
      name: "Promoted Content",
      description:
        "Spotlight your prime-time content and ensure it stands tall and strong",
      icon: "/images/hub/layouts/assets_carousel.gif",
      data: {
        columns: [
          {
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: "coaching_promoted_content",
              entityType: "coaching",
              layoutStyle: "promoted_content",
              cardStyle: "small",
              smartFilter: "published_learnings",
            },
          },
        ],
      },
    },
  ],
};